<vw-toast-popup
  [isOpen]="push.sheetOpen()"
  [title]="'push.ask.title' | translate"
  (close)="push.later()"
>
  <div class="flex flex-col px-4 pb-6">
    <!-- Willy au téléphone à côté de la promesse, puis le choix en pleine largeur. -->
    <div class="flex items-center gap-4">
      <img
        src="assets/images/willy/willy_phone.png"
        alt=""
        class="h-16 w-16 shrink-0 rounded-pill bg-vw-surface-tint object-cover object-top"
      />
      <p class="text-body text-vw-body">
        {{ "push.ask.text" | translate }}
      </p>
    </div>
    <vw-button
      look="primary"
      [label]="'push.ask.accept' | translate"
      customClass="mt-6 w-full"
      data-testid="push-accept"
      (click)="push.accept()"
    />
    <vw-button
      look="quiet"
      [label]="'push.ask.later' | translate"
      customClass="mt-2 w-full"
      data-testid="push-later"
      (click)="push.later()"
    />
  </div>
</vw-toast-popup>
